import downloadFile from "./downloadFile";

/**
 * 由于千牛有域名请求白名单，此处方法为hack方法
 *
 * 通过downloadFile下载文件获取到千牛本地地址，返回给前端img组件使用
 */
export default async function getProxyImageBase64(src: string) {
    if (!import.meta.env.VITE_IS_QN) {
        return src;
    }

    if (!src) {
        return "";
    }

    if (!src.startsWith("http")) {
        return src;
    }

    if (src.startsWith("data:")) {
        return src;
    }

    if (src.includes("alicdn.com")) {
        return src;
    }

    let result = "";

    try {
        result = await downloadFile(src);
    } catch (error) {}

    return result;
}
